import React from 'react';
import PropTypes from 'prop-types';

// Component
import ArticlesList from 'components/ArticlesList';

// Styles
import cn from 'classnames/bind';
import styles from './styles.styl';

const cx = cn.bind(styles);

/** Список статей */
const CategoryArticlesList = ({
  title,
  image,
  items,
  page,
  pagesLength,
  paginationHref,
  changePage,
  isLoading,
  className,
  promos,
  indexOfPromo,
}) => {
  return (
    <div className={cx('CategoryArticlesList', className)} data-anchor="articles">
      <ArticlesList
        className={cx('CategoryArticlesList__list')}
        isExistPagination
        title={title}
        image={image}
        isLoading={isLoading}
        articles={items}
        page={page}
        length={pagesLength}
        paginationHref={paginationHref}
        changePage={changePage}
        promos={promos}
        indexOfpromo={indexOfPromo}
      />
    </div>
  );
};

CategoryArticlesList.propTypes = {
  title: PropTypes.string,
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  items: PropTypes.array,
  page: PropTypes.number,
  pagesLength: PropTypes.number,
  paginationHref: PropTypes.func,
  changePage: PropTypes.func,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
  promos: PropTypes.array,
  indexOfPromo: PropTypes.number,
};

CategoryArticlesList.defaultProps = {
  title: '',
  image: '',
  items: [],
  page: 1,
  pagesLength: 1,
  paginationHref: () => undefined,
  changePage: () => {},
  isLoading: false,
  className: '',
};

export default CategoryArticlesList;
